import React from "react";
import { Tag } from "../../../../design-system";
import { Tone } from "../model/types";

interface Palette {
    bg: string;
    border: string;
    text: string;
}

const PALETTES: Record<Tone, Palette> = {
    green: { bg: "#f6ffed", border: "#b7eb8f", text: "#389e0d" },
    teal: { bg: "#e6fffb", border: "#87e8de", text: "#08979c" },
    blue: { bg: "#e6f7ff", border: "#91d5ff", text: "#096dd9" },
    amber: { bg: "#fff7e6", border: "#ffd591", text: "#d46b08" },
    red: { bg: "#fff1f0", border: "#ffa39e", text: "#cf1322" },
    slate: { bg: "#fafafa", border: "#d9d9d9", text: "rgba(0, 0, 0, 0.65)" },
};

interface Props {
    tone: Tone;
    children: React.ReactNode;
}

export const StatusTag: React.FC<Props> = ({ tone, children }) => {
    const p = PALETTES[tone];
    return (
        <Tag
            style={{
                background: p.bg,
                color: p.text,
                border: `1px solid ${p.border}`,
                borderRadius: 9999,
                fontWeight: 600,
            }}
        >
            {children}
        </Tag>
    );
};
